import { condensatePhaseVolumeFactorCalculator as petroskyFarshadGom } from "./petroskyFarshadGom";

import type {
  CondensatePhasePVTFluidProperties,
  CondensatePhasePVTFluidPropertyParameters
} from "../d";

// PVT!BJ97:BJ121 — Petrosky and Farshad is the only condensate PVT correlation in the sheet
const condensatePhaseVolumeFactorCalculator = petroskyFarshadGom;

export const emptyCondensatePVT: CondensatePhasePVTFluidProperties = {
  x: 0,
  solutionGasRso: 0,
  solutionGasRsoAtReservoir: 0,
  dewPointPressurePSIA: 0,
  solutionGasAtDewPointRsb: 0,
  condensateFormationVolumeFactorSatBo: 0,
  condensateFormationVolumeFactorAtDewPointBob: 0,
  compressibilityUnSatCo: 0,
  compressibilityLimitedUnSatCo: 0,
  condensateFormationVolumeFactorUnSatBo: 0,
  condensatePhaseVolumeFactor: 0
};

const finiteOrZero = (value: number) => (Number.isFinite(value) ? value : 0);

export function getCondensatePVT(
  params: CondensatePhasePVTFluidPropertyParameters
): CondensatePhasePVTFluidProperties {
  const {
    solutionGasRsoCalculator,
    dewPointPressurePSIACalculator,
    condensatePhaseVolumeFactorBoCalculator
  } = condensatePhaseVolumeFactorCalculator;

  const { x, solutionGasRsoInSitu, solutionGasRsoAtReservoir } =
    solutionGasRsoCalculator(params);

  const { dewPointPressurePSIA } = dewPointPressurePSIACalculator({
    ...params,
    x,
    solutionGasRsoInSitu
  });

  const boIntermediates = condensatePhaseVolumeFactorBoCalculator({
    ...params,
    x,
    solutionGasRsoInSitu,
    solutionGasRso: solutionGasRsoInSitu,
    dewPointPressurePSIA
  });

  // PVT!BJ121
  const condensatePhaseVolumeFactor =
    params.pressurePSIA > dewPointPressurePSIA
      ? boIntermediates.condensateFormationVolumeFactorUnSatBo
      : boIntermediates.condensateFormationVolumeFactorSatBo;

  return {
    x: finiteOrZero(x),
    solutionGasRso: finiteOrZero(solutionGasRsoInSitu),
    solutionGasRsoAtReservoir: finiteOrZero(solutionGasRsoAtReservoir),
    dewPointPressurePSIA: finiteOrZero(dewPointPressurePSIA),
    solutionGasAtDewPointRsb: finiteOrZero(
      boIntermediates.solutionGasAtDewPointRsb
    ),
    condensateFormationVolumeFactorSatBo: finiteOrZero(
      boIntermediates.condensateFormationVolumeFactorSatBo
    ),
    condensateFormationVolumeFactorAtDewPointBob: finiteOrZero(
      boIntermediates.condensateFormationVolumeFactorAtDewPointBob
    ),
    compressibilityUnSatCo: finiteOrZero(
      boIntermediates.compressibilityUnSatCo
    ),
    compressibilityLimitedUnSatCo: finiteOrZero(
      boIntermediates.compressibilityLimitedUnSatCo
    ),
    condensateFormationVolumeFactorUnSatBo: finiteOrZero(
      boIntermediates.condensateFormationVolumeFactorUnSatBo
    ),
    condensatePhaseVolumeFactor: finiteOrZero(condensatePhaseVolumeFactor)
  };
}
